module.exports = __webpack_public_path__ + "media/img/testimonial/aliff-aedb161301ecad72b2bd50dacd41948f.jpeg";